export const BASE_URL = process.env.REACT_APP_BASE_URL;

export const ERRORS = {
    "11000": "Email ya existe intenta con otro"
}
